import axios from "axios";

// Hardcoded key to ensure it works regardless of .env issues
const API_KEY = process.env.REACT_APP_API_KEY;
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const api = axios.create({
  baseURL: `${BASE_URL}/api`,
  headers: {
    "X-API-KEY": API_KEY,
    "Accept": "application/json",
    "Content-Type": "application/json"
  }
});

// Interceptor to ensure API Key is sent in both Header and Query Param (as fallback)
api.interceptors.request.use((config) => {
  // Add to headers (redundant but safe)
  config.headers["X-API-KEY"] = API_KEY;

  // Add to query params as a backup for CORS header stripping
  config.params = {
    ...config.params,
    api_key: API_KEY,      // snake_case
    "api-key": API_KEY,    // kebab-case
    key: API_KEY           // simple key
  };

  return config;
});

export const getSettings = () => api.get("/settings");
export const getHome = () => api.get("/home");
export const getServices = () => api.get("/services");
export const getService = (slug) => api.get(`/service/${slug}`);
export const getProjects = () => api.get("/projects");
export const getProject = (slug) => api.get(`/project/${slug}`);
export const getMap = () => api.get("/map");
export const getBranch = (slug) => api.get(`/branch/${slug}`);
export const getJobs = () => api.get("/jobs");
export const submitJob = (data) => api.post("/submit-job", data, {
  headers: {
    "Content-Type": "multipart/form-data",
  },
});
export const getBlogs = () => api.get("/blogs");
export const getBlog = (slug) => api.get(`/blog/${slug}`);
export const getAbout = () => api.get("/about");


export default api;
